/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Comment = 'Website.SurveySystem.Comment';
export const Finish = 'Website.SurveySystem.Finish';
